import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "American Football",
    Baseball: "Honkbal",
    Basketball: "Basketbal",
    Boxing: "Boksen",
    Chess: "Schaken",
    Cricket: "Cricket",
    Darts: "Darts",
    Entertainment: "Vermaak",
    "E-Sports": "eSport",
    Football: "Voetbal",
    "Formula 1": "Formule 1",
    "Gaelic Football": "Gaelic Football",
    "Generic Sport": "Generieke sport",
    Golf: "Golf",
    "Greyhound Racing": "Windhondenrennen",
    Handball: "Handbal",
    "Ice Hockey": "IJshockey",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "NASCAR",
    Politics: "Politiek",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tafeltennis",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{naam} om te winnen",
    WinFirstRound: "{name} om de eerste ronde te winnen",
    FirstTouchdown: "{name} om als eerste een touchdown te scoren",
    FirstTry: "{name} om eerst een try te scoren",
    TotalGoals: "{name} Totaal aantal goals",
    TotalRuns: "{name} Totaal aantal runs",
    TotalPoints: "{name} Totaal aantal punten",
    TopBatsman: "{name} om Top Batsman te worden",
    TopBowler: "{name} om Top Bowler te worden",
    FirstScore: "{naam} om als eerste te scoren"
  },
  PromoTexts: {
    Pick: "Maak je keuzes",
    Bet: "Weddenschap",
    Pays: "Uitbetaling"
  },
  DateTimeTexts: {
    Today: "Vandaag",
    Tomorrow: "Morgen",
    Live: "Live"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Maak je keuzes",
    Return: "Uitbetaling",
    Stake: "Weddenschap",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Doelpunten gescoord",
    shots: "Schoten",
    shots_on_target: "Schoten op doel",
    ball_possession: "Balbezit",
    goals_conceded: "Doelpunten tegen",
    "Per match": "Per wedstrijd",
    H2H: "H2H",
    W: "W",
    D: "G",
    L: "V",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing",
    rushing_yards_per_game: "Yards",
    rushing_touchdowns: "Touchdowns",
    rushing_percentage: "%",
    passing_stats: "Passing",
    passing_yards_per_game: "Yards",
    passing_touchdowns: "Touchdowns",
    passing_percentage: "%"
  }
};
